import background from "assets/img/Gemini_Generated_Image_i1b81ai1b81ai1b8.png";

/**
 * Returns the Chakra style props for the login page background container.
 * @returns {Object} Chakra style-prop object
 */
export function getPageContainerProps() {
    return {
        minH: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgImage: `url(${background})`,
        bgSize: "cover",
        bgPosition: "center",
        bgRepeat: "no-repeat",
        p: "16px"
    };
}

/**
 * Returns the Chakra style props for the login form card wrapper.
 * @returns {Object} Chakra style-prop object
 */
export function getCardContainerProps() {
    return {
        w: "100%",
        maxW: "450px",
        bg: "rgba(30, 30, 30, 0.95)",
        backdropFilter: "blur(20px)",
        borderRadius: "16px",
        border: "1px solid rgba(255, 255, 255, 0.08)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
        overflow: "hidden"
    };
}

/**
 * Returns the shared Chakra Input style props for email/password fields.
 * @param {boolean} isMobile - Whether the viewport is mobile-sized
 * @returns {Object} Chakra Input style-prop object
 */
export function getInputProps(isMobile) {
    return {
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: isMobile ? "0.9rem" : "0.95rem",
        bg: "rgba(255, 255, 255, 0.05)",
        borderRadius: "8px",
        borderColor: "rgba(255, 255, 255, 0.1)",
        _hover: { borderColor: "rgba(255, 255, 255, 0.2)" },
        _focus: { borderColor: "#667eea", boxShadow: "0 0 0 1px #667eea" },
        _placeholder: { color: "rgba(255, 255, 255, 0.4)" },
        _disabled: { opacity: 0.6 }
    };
}

/**
 * Returns the Chakra style props for the submit button.
 * @param {boolean} isMobile - Whether the viewport is mobile-sized
 * @returns {Object} Chakra Button style-prop object
 */
export function getSubmitButtonProps(isMobile) {
    return {
        mt: "16px",
        w: "100%",
        h: "48px",
        bgGradient: "linear(135deg, #667eea 0%, #764ba2 100%)",
        color: "#fff",
        fontSize: isMobile ? "0.9rem" : "0.95rem",
        fontWeight: 700,
        borderRadius: "8px",
        boxShadow: "0 4px 16px rgba(102, 126, 234, 0.4)",
        transition: "all 0.3s ease",
        _hover: {
            bgGradient: "linear(135deg, #5568d3 0%, #6a3f8f 100%)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)"
        },
        _active: { transform: "translateY(0)" },
        _disabled: {
            bg: "rgba(255, 255, 255, 0.1)",
            bgGradient: "none",
            color: "rgba(255, 255, 255, 0.4)",
            boxShadow: "none",
            cursor: "not-allowed"
        }
    };
}
